import Footer from "../components/Footer/Footer"
import BackgroundImg2 from "../components/BackgroundImg2/BackgroundImg2"
import Works from "../components/Works"

const Projects = () => {
  return (
    <div>
      <BackgroundImg2 heading='PROJECTS' text='A few of my most recent projects' />
      <Works />
      <Footer />
    </div>
  )
}

export default Projects